module.exports = __webpack_public_path__ + "static/media/marker.29d9399a.svg";